
import { type Crop as CropType } from 'react-image-crop';

export function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) {
  return {
    unit: '%',
    x: 25,
    y: 25,
    width: 50,
    height: 50,
  } as CropType;
}

export const getCroppedImg = (image: HTMLImageElement, crop: CropType): Promise<Blob> => {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  // Convert percentage crop to pixel values
  const pixelCrop = {
    x: (crop.x * image.width) / 100,
    y: (crop.y * image.height) / 100,
    width: (crop.width * image.width) / 100,
    height: (crop.height * image.height) / 100,
  };

  // Set canvas size to match the cropped image size
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  // Draw only the cropped portion of the image
  ctx.drawImage(
    image,
    pixelCrop.x * scaleX,
    pixelCrop.y * scaleY,
    pixelCrop.width * scaleX,
    pixelCrop.height * scaleY,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // Create a new promise that resolves with the blob
  return new Promise((resolve, reject) => {
    try {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Failed to create blob'));
            return;
          }
          resolve(blob);
        },
        'image/jpeg',
        0.95
      );
    } catch (err) {
      reject(err);
    }
  });
};
